/* src/app/umbrella-common/components/sticky-on-scroll-panel/style.scss */
.sticky-wrapper.stick-to-bottom {
  box-shadow: 0 0 45px 5px rgba(0, 0, 0, 0.3);
  background-color: white;
  position: fixed;
  z-index: 1001;
  bottom: 0;
  min-height: 88px;
  width: 100%;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  transition: transform 0.5s;
  transition-property: transform;
  transform: translateY(-80px);
}
/*# sourceMappingURL=style.css.map */
